import { format } from 'date-fns'

type DateParts = [number, number, number]

export const localizationDateFormat = "yyyy-MM-dd'T'HH:mm:ssXXX"
export const localizationDateNoTimeZoneFormat = "yyyy-MM-dd'T'HH:mm:ss"

// Type for date format configurations
interface DateFormat {
  regex: RegExp
  extract: (parts: DateParts) => { year: number; month: number; day: number }
}

const dateFormats: DateFormat[] = [
  {
    regex: /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/,
    extract: ([month, day, year]: DateParts) => ({
      year,
      month: month - 1,
      day,
    }), // mm/dd/yyyy (allows one or two digits for month and day)
  },
  {
    regex: /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/,
    extract: ([day, month, year]: DateParts) => ({
      year,
      month: month - 1,
      day,
    }), // dd/mm/yyyy (allows one or two digits for day and month)
  },
  {
    regex: /^\d{4}\/(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])$/,
    extract: ([year, month, day]: DateParts) => ({
      year,
      month: month - 1,
      day,
    }), // yyyy/mm/dd (allows one or two digits for day and month)
  },
]

// Function to parse date from a string using defined formats
const parseDate = (dateString: string): Date | null => {
  for (const { regex, extract } of dateFormats) {
    if (regex.test(dateString)) {
      const parts = dateString.split('/').map(Number) as DateParts
      const { year, month, day } = extract(parts)
      return new Date(year, month, day)
    }
  }
  return null
}

export function detectAndConvertDateTime(dateTimeString: string): string {
  const [dateString, timeString] = dateTimeString.split(' ')

  const newDate = parseDate(dateString)

  if (newDate && !isNaN(newDate.getTime())) {
    const [hours = 0, minutes = 0, seconds = 0] = timeString
      ? timeString.split(':').map((part) => parseInt(part, 10))
      : [0, 0, 0]

    newDate.setHours(hours, minutes, seconds)

    if (isNaN(newDate.getTime())) {
      return dateTimeString
    }

    return format(newDate, localizationDateFormat)
  }

  return dateTimeString
}

export function setDateValue(value: any): string | undefined {
  if (!value) return undefined

  if (value) {
    return value instanceof Date
      ? detectAndConvertDateTime((value as Date).toISOString())
      : detectAndConvertDateTime(value)
  }
}
